(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-input"] && !Shopify.designMode) return;
  try {
    
// 必要に応じてJavaScriptを追加

  } catch(e) { console.error(e); }
})();
})();
